import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import "./index.scss";

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) =>
    location.pathname === path ? "active" : "";

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header id="header" className="navbar-fixed-top header">
      <div className="container">
        <div className="row">
          
          {/* Logo */}
          <div className="navbar-left">
            <div className="navbar-brand">
              <Link to="/">
                <img src="/images/logo2.png" alt="logo" />
              </Link>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="navbar-right desktop-menu">
            <div className={`nav-option ${isActive("/")}`}>
              <Link to="/">Home</Link>
            </div>
            <div className={`nav-option ${isActive("/about")}`}>
              <Link to="/about">Who We Are</Link>
            </div>
            <div className={`nav-option ${isActive("/services")}`}>
              <Link to="/services">Our Services</Link>
            </div>
            <div className={`nav-option ${isActive("/business-classification")}`}>
              <Link to="/business-classification">Business Classification</Link>
            </div>
            <div className={`nav-option ${isActive("/testimonials")}`}>
              <Link to="/testimonials">Testimonials</Link>
            </div>
            <div className={`nav-option ${isActive("/contact")}`}>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          {/* Burger Icon */}
          <div className="burger-menu" onClick={toggleMenu}>
            {menuOpen ? <CloseOutlined /> : <MenuOutlined />}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={toggleMenu}>Home</Link>
        <Link to="/about" onClick={toggleMenu}>Who We Are</Link>
        <Link to="/services" onClick={toggleMenu}>Our Services</Link>
        <Link to="/business-classification" onClick={toggleMenu}>
          Business Classification
        </Link>
        <Link to="/testimonials" onClick={toggleMenu}>Testimonials</Link>
        <Link to="/contact" onClick={toggleMenu}>Contact</Link>
      </div>
    </header>
  );
};

export default Header;